import { FC, useCallback, useRef, useState } from "react";
import { useTranslation } from "react-i18next";

import { REDESIGN_NS } from "../i18n";
import { IconChevronDown } from "../ui/icons";
import { useDismissable } from "../ui/useDismissable";

const LANGUAGES = [
  { code: "tr", short: "TR", labelKey: "Turkish (TR)" },
  { code: "en", short: "EN", labelKey: "English (EN)" },
];

const LanguageMenu: FC = () => {
  const { i18n, t } = useTranslation(REDESIGN_NS);
  const [isOpen, setIsOpen] = useState(false);
  const anchorRef = useRef<HTMLDivElement>(null);

  const close = useCallback(() => setIsOpen(false), []);
  useDismissable(anchorRef, isOpen, close);

  const current = i18n.language?.startsWith("en") ? "en" : "tr";
  const currentShort = LANGUAGES.find((l) => l.code === current)?.short || "TR";

  const select = (code: string) => {
    // documentElement.lang'i AppShell dil değişiminde kendisi yazıyor.
    i18n.changeLanguage(code);
    close();
  };

  return (
    <div className="sso-rd__menu-anchor" ref={anchorRef}>
      <button
        type="button"
        className="sso-rd__lang-btn"
        onClick={() => setIsOpen((open) => !open)}
        aria-haspopup="menu"
        aria-expanded={isOpen}
        aria-label={t("Language")}
      >
        {currentShort}
        <IconChevronDown size={13} />
      </button>

      <div
        className={"sso-rd__lang-menu" + (isOpen ? " is-open" : "")}
        role="menu"
      >
        {LANGUAGES.map((language) => (
          <button
            key={language.code}
            type="button"
            role="menuitem"
            className={
              "sso-rd__lang-option" +
              (language.code === current ? " is-active" : "")
            }
            onClick={() => select(language.code)}
          >
            {t(language.labelKey)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default LanguageMenu;
